import { NgIf, CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { CanComponentDeactivate } from '../../services/unsaved-changes.guard';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { environment } from '../../environments/environment';
import { InferenceService } from '../../services/api-services/inference.service';
import { UserSessionsService } from '../../services/api-services/user-sessions.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../dialog/dialog.component';
import { FeatherModule } from 'angular-feather';

@Component({
  selector: 'app-training',
  standalone: true,
  imports: [MatCardModule, MatMenuModule, MatPaginatorModule, MatTableModule, NgIf, MatCheckboxModule, MatProgressSpinnerModule,
      MatInputModule, ReactiveFormsModule, MatButtonModule, MatTabsModule, MatFormFieldModule, FormsModule,
      MatProgressBarModule, MatSelectModule, MatOptionModule, RouterModule, MatButtonToggleModule, CommonModule, MatIconModule, FeatherModule],
  templateUrl: './training.component.html',
  styleUrl: './training.component.scss'
})
export class TrainingComponent implements OnInit, CanComponentDeactivate {
      public fullProductPhoto: string | null = null;
      public labelPhoto: string | undefined = undefined;
      public priceTagPhoto: string | undefined = undefined;

      fullProductLoading = false;
      labelPhotoLoading = false;
      priceTagPhotoLoading = false;
  
      estimateButtonDisabled = true;
  
      submitDisabled = false;
      isLoading = false;
      price = 0;

      // Session-based insertion
      isAddingToSession = false;
      activeSessionName = '';
      private activeSessionId: number | null = null;

      originalPrice = 0;
  
      outputBrand = '';
      outputColor = '';
      outputItem = '';
      outputMaterial = '';
  
      originalOutputBrand = '';
      originalOutputColor = '';
      originalOutputItem = '';
      originalOutputMaterial = '';
  
      editingDetails = false;
      editDetailsBtnName = "Edit product info";
      editButtonIcon = 'edit'
  
      showAlertInfo = false;
      alertInfoText = '';
  
      showSuccessInfo = false;
      successInfoText = '';
  
      lastImageId: string | undefined = undefined;
      lastBrandId: string | undefined = undefined;
      lastClusterId: string | undefined = undefined;
      updatesResult: any | undefined = undefined;
  
      selectedTab = 0;
      estimationsTabDisabled = true;
      estimationsLoading = false;
      condition = 'Good';
      age = 'Current';
  
      updatePriceForProductBtnName = "Update & Continue"
      updateLoading = false;
  
      pricingLoading = false;
  
      constructor(private apiInferenceService: InferenceService,
         private userSessionsService: UserSessionsService,
         private changeDetector: ChangeDetectorRef, private dialog: MatDialog
      ) {
        // this.toggleService.toggle();
      }
  
      hasUnsavedChanges(): boolean {
        return this.fullProductPhoto !== null && this.fullProductPhoto !== undefined;
      }

      @HostListener('window:beforeunload', ['$event'])
      onBeforeUnload(event: BeforeUnloadEvent): void {
        if (this.hasUnsavedChanges()) {
          event.preventDefault();
          event.returnValue = '';
        }
      }

      canDeactivate(): boolean {
        if (this.hasUnsavedChanges()) {
          return window.confirm('Are you sure you want to leave this page?');
        }
        return true;
      }

      ngOnInit(): void {
        this.refreshView();
      }

      refreshView() {
        this.showAlertInfo = false;
        this.showSuccessInfo = false;
  
        this.isLoading = false;
        this.submitDisabled = false;

        this.fullProductLoading = false;
        this.labelPhotoLoading = false;
        this.priceTagPhotoLoading = false;
  
        this.outputBrand = 'unknown';
        this.outputColor = 'unknown';
        this.outputItem = 'unknown';
        this.outputMaterial = 'unknown';
  
        this.price = 0;

        // Load active session
        this.userSessionsService.getActiveSession().subscribe({
          next: response => {
            if (response.session) {
              this.activeSessionId = response.session.id;
              this.activeSessionName = response.session.name;
              this.isAddingToSession = true;
            } else {
              this.activeSessionId = null;
              this.activeSessionName = '';
              this.isAddingToSession = false;
            }
          },
          error: () => {
            this.activeSessionId = null;
            this.activeSessionName = '';
            this.isAddingToSession = false;
          }
        });
  
      }

      onCancelSessionInsertion(): void {
        this.isAddingToSession = false;
        this.activeSessionId = null;
        this.activeSessionName = '';
        this.userSessionsService.clearActiveSession().subscribe({
          next: response => {
            if (!environment.production) {
              console.log(response);
            }
          },
          error: error => {
            if (!environment.production) {
              console.log(error);
            }
          }
        });
      }

      predict() {
        this.estimationsTabDisabled = false;
        this.selectedTab = 1;
        this.estimationsLoading = true;
  
        this.condition = 'Good';
        this.age = 'Current';
  
        this.showAlertInfo = false;
        this.showSuccessInfo = false;
  
        this.changeDetector.detectChanges();
  
        this.inference();
      }

      inference() {
        this.apiInferenceService.uploadPhotosForTraining(
          this.fullProductPhoto,
          this.labelPhoto,
          this.priceTagPhoto
        ).subscribe({
          next: response => {
            if (!environment.production) {
              console.log(response);
            }

            this.originalOutputBrand = response["brand"];
            this.originalOutputItem = response["item"];
            this.originalOutputColor = response["color"];
            this.originalOutputMaterial = response["material"];

            this.outputBrand = response["brand"];
            this.outputItem = response["item"];
            this.outputColor = response["color"];
            this.outputMaterial = response["material"];

            const raw = response["price"];
            const parsed = Number(raw);

            this.price = isNaN(parsed) ? 0 : parsed;
            this.originalPrice = isNaN(parsed) ? 0 : parsed;

            if (this.price === 0) {
              this.alertInfoText = 'The price of the product was not detected. Please edit the price field and save.';
              this.showAlertInfo = true;
            }
          },
          error: error => {
            if (!environment.production) {
              console.log(error);
            }
            this.estimationsLoading = false;
            this.changeDetector.detectChanges();
          },
          complete: () => {
            this.estimationsLoading = false;
            this.changeDetector.detectChanges();
          }
        });
      }
  
      selectCondition(condition: string) {
        this.condition = condition;
      }
  
      selectAge(age: string) {
        this.age = age;
      }
  
      openFullFileSelector() {
        const fileInput = document.getElementById('fullFileInput') as HTMLInputElement;
        if (fileInput) {
          fileInput.click();
        }
      }
  
      openLabelFileSelector() {
        const fileInput = document.getElementById('labelFileInput') as HTMLInputElement;
        if (fileInput) {
          fileInput.click();
        }
      }

      openPriceTagFileSelector() {
        const fileInput = document.getElementById('priceTagFileInput') as HTMLInputElement;
        if (fileInput) {
          fileInput.click();
        }
      }
  
      removeFullPhoto() {
        this.fullProductPhoto = null;
        this.estimateButtonDisabled = true;
        const fileInput = document.getElementById('fullFileInput') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
        this.changeDetector.detectChanges();
      }
  
      removeLabelPhoto() {
        this.labelPhoto = undefined;
  
        const fileInput = document.getElementById('labelFileInput') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
        this.changeDetector.detectChanges();
      }

      removePriceTagPhoto() {
        this.priceTagPhoto = undefined;
  
        const fileInput = document.getElementById('priceTagFileInput') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
        this.changeDetector.detectChanges();
      }
  
      onFileSelectedFullItemPhoto(event: Event) {
        const fileInput = event.target as HTMLInputElement;
        this.loadResizedPhoto(fileInput, 'product');
      }
  
      onFileSelectedLabelPhoto(event: Event) {
        const fileInput = event.target as HTMLInputElement;

        this.loadResizedPhoto(fileInput, 'label');
      }

      onFileSelectedPriceTagPhoto(event: Event) {
        const fileInput = event.target as HTMLInputElement;
        this.loadResizedPhoto(fileInput, 'priceTag');
      }
  
      checkTableInput() {
        if (this.outputBrand === 'unknown' || this.outputBrand === "") {
          this.outputBrand = "unknown";
          this.alertInfoText = "The product's brand could not be identified. Please edit the brand field and save your changes.";
          this.showAlertInfo = true;
        } else {
          this.showAlertInfo = false;
        }
        if (this.outputColor === "") {
          this.outputColor = 'unknown';
        }
        if (this.outputItem === "") {
          this.outputItem = 'unknown';
        }
        if (this.outputMaterial === "") {
          this.outputMaterial = 'unknown';
        }
        if (this.price <= 0) {
          this.alertInfoText = "The product's price should not be 0 or negative. Please edit the price field and save your changes.";
          this.showAlertInfo = true;
          this.submitDisabled = true;
        } else {
          this.submitDisabled = false;
        }
      }
  
      onEditItemDetails() {
        if (!this.editingDetails) {
          this.editingDetails = true;
  
          this.originalOutputBrand = this.outputBrand;
          this.originalOutputColor = this.outputColor;
          this.originalOutputItem = this.outputItem;
          this.originalOutputMaterial = this.outputMaterial;

          const rawPrice = Number(this.price);
          this.originalPrice = isNaN(rawPrice) ? this.price : this.originalPrice;

          if (isNaN(rawPrice)) {
            this.alertInfoText = 'The price must be a number.';
            this.showAlertInfo = true;
          } else {
            this.showAlertInfo = false;
          }
  
          this.editDetailsBtnName = 'Save changes';
          this.editButtonIcon = 'save';
        } else {
          this.editingDetails = false;
          this.editDetailsBtnName = "Edit product info";
          this.editButtonIcon = 'edit';

          this.showAlertInfo = false;
          this.submitDisabled = false;

          this.checkTableInput();
  
          this.changeDetector.detectChanges();
  
        }
      }
  
      onCancelEditingDetails() {
        this.editingDetails = false;
        this.editDetailsBtnName = "Edit product info";
        this.editButtonIcon = 'edit';
  
        this.outputBrand = this.originalOutputBrand;
        this.outputColor = this.originalOutputColor;
        this.outputItem = this.originalOutputItem;
        this.outputMaterial = this.originalOutputMaterial;
        this.price = this.originalPrice;

        this.checkTableInput();
  
      }
  
      continueAndUpdateModels() {
        this.estimationsLoading = true;
        this.submitDisabled = true;
        this.changeDetector.detectChanges();

        this.updateDetection();
      }

      updateDetection() {
        if (!environment.production) {
          console.log(this.outputItem);
          console.log(this.outputBrand);
          console.log(this.outputMaterial);
          console.log(this.outputColor);
          console.log(this.price);
          console.log(this.age);
          console.log(this.condition);
        }
        if (this.price <= 0) {
          this.alertInfoText = 'The price should not be zero or negative. Please edit the price field.';
          this.showAlertInfo = true;
          this.estimationsLoading = false;
          this.changeDetector.detectChanges();
          return;
        } else {
          this.showAlertInfo = false;
        }
        this.apiInferenceService.updateForTraining(
          this.fullProductPhoto,
          this.price,
          this.outputItem,
          this.outputMaterial,
          this.outputColor,
          this.outputBrand,
          this.age,
          this.condition,
          this.labelPhoto,
          this.priceTagPhoto
        ).subscribe({
          next: response => {
            if (!environment.production) {
              console.log(response);
            }
          },
          error: error => {
            if (!environment.production) {
              console.log(error);
            }
            this.estimationsLoading = false;
            this.showSuccessInfo = false;
            window.alert('An error occurred while trying to update the AI models. Please try again or contact admin.');
          },
          complete: () => {
            this.estimationsLoading = false;
            this.successInfoText = 'Updated successfully.';
            this.showSuccessInfo = true;
          }
        })
      }
  
      startAgain() {
        this.selectedTab = 0;
        this.removeFullPhoto();
        this.removeLabelPhoto();
        this.removePriceTagPhoto();
        this.refreshView();
        this.estimationsTabDisabled = true;
        this.changeDetector.detectChanges();
      }
    
      private loadResizedPhoto(fileInput: any, photoType: string, maxDimension = 1000) {
        if (!fileInput.files || !fileInput.files[0]) {
          this.fullProductLoading = false;
          this.labelPhotoLoading = false;
          this.priceTagPhotoLoading = false;
          this.changeDetector.detectChanges();
          return;
        }

        const file = fileInput.files[0];
        console.log(`Original file size: ${file.size} bytes`);

        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
        const img = new Image();
        img.onload = () => {
          if (photoType === 'product') {
              this.fullProductLoading = true;
              this.changeDetector.detectChanges();
          } else if (photoType === 'label') {
              this.labelPhotoLoading = true;
              this.changeDetector.detectChanges();
          } else {
              this.priceTagPhotoLoading = true;
              this.changeDetector.detectChanges();
          }

          let { width, height } = img;
          if (Math.max(width, height) > maxDimension) {
            const scale = maxDimension / Math.max(width, height);
            width = Math.round(width * scale);
            height = Math.round(height * scale);
          }

          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            console.error('Canvas rendering context is not available.');
            return;
          }
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            blob => {
              if (!blob) {
                console.error('Failed to create blob from canvas.');
                return;
              }
              console.log(`Resized blob size: ${blob.size} bytes`);

              const reader2 = new FileReader();
              reader2.onload = (e2: ProgressEvent<FileReader>) => {
                if (photoType === 'label') {
                  this.labelPhoto = e2.target?.result as string;
                  this.labelPhotoLoading = false;
                } else if (photoType === 'product') {
                  this.fullProductPhoto = e2.target?.result as string;
                  this.estimateButtonDisabled = false;

                  this.fullProductLoading = false;
                } else {
                  this.priceTagPhoto = e2.target?.result as string;
                  this.priceTagPhotoLoading = false;
                }
                this.changeDetector.detectChanges();
              };
              reader2.readAsDataURL(blob);
            },
            'image/jpeg',
            0.8 // quality 0.0–1.0
          );
        };

        img.onerror = () => {
          console.error('Failed to load image for resizing.');
        };

        // Kick off the image load
        img.src = e.target?.result as string;
      };

      reader.onerror = () => {
        console.error('Failed to read file as Data-URL.');
      };

      reader.readAsDataURL(file);
    }

}
